import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'cigna-cafooter-secure',
  templateUrl: './footer-secure.component.html',
  styleUrls: ['./footer-secure.component.scss'],
})
export class FooterSecureComponent {
  currentYear: string = new Date().getFullYear().toString();
  isLoginPage = true;
  isFromBRPortal: string;
  constructor(private cookieService: CookieService) {
    this.isFromBRPortal = this.cookieService.get('is-broker');
  }
}
